import { SxProps, Theme } from '@mui/material';

import { UserRef } from '@/tracker/types';
import { SearchSelect } from '@/tracker/ui/SearchSelect';
import { getDisplayName, getId } from '@/tracker/utils/optionGetters';

import { searchActiveUsers } from '../searchActiveUsers';

type Props = {
  value: UserRef | null;
  onChange: (user: UserRef | null) => void;
  ariaLabel: string;
  placeholder?: string;
  sx?: SxProps<Theme>;
};

/** Выбор активного пользователя поиском на сервере: исполнитель в фильтрах и формах */
const UserSelect: React.FC<Props> = ({ value, onChange, ariaLabel, placeholder, sx }) => (
  <SearchSelect
    value={value}
    onChange={onChange}
    search={searchActiveUsers}
    getId={getId}
    getLabel={getDisplayName}
    ariaLabel={ariaLabel}
    placeholder={placeholder}
    sx={sx}
  />
);

export { UserSelect };
